import React, { useCallback, useMemo } from 'react';
import MobileButtonsListItemContent from './mobile-buttons-list-item-content';
import { PORTAL_TYPE } from '../../../../types/app.types';
import { ButtonListDataItem } from '../../buttons-list.data';
import useDispatchButton from '../../../../hooks/use-dispatch-button.hook';
import { useParamsContext } from '../../../../params/params-context';

interface MobileButtonsListItemProps {
  item: ButtonListDataItem;
  toggleButton: (id: PORTAL_TYPE) => void;
  isActive: boolean;
}

const MobileButtonsListItem: React.FunctionComponent<MobileButtonsListItemProps> = ({
  item,
  isActive,
  toggleButton
}) => {
  const { onClickHandler } = useDispatchButton(item);
  const { portalType } = useParamsContext();

  const toggleHandler = useCallback(() => {
    toggleButton(item.id);
  }, [item.id, toggleButton]);

  const isGreyed = useMemo(
    () => portalType === PORTAL_TYPE.UMER && item.id !== PORTAL_TYPE.UMER,
    [item.id, portalType]
  );

  return (
    <MobileButtonsListItemContent
      isActive={isActive}
      content={`dispatchPage.descriptions.${item.id}`}
      header={`dispatchPage.buttons.${item.id}`}
      toggleHandler={toggleHandler}
      img={item.img}
      goForward={onClickHandler}
      isGreyed={isGreyed}
    />
  );
};

export default MobileButtonsListItem;
